/* ==========================================================================
   Bold Grip Socks: shared colourway helper for every bundle picker.
   Reads window.BM_COLORWAYS (snippets/bm-colorways.liquid). One list, so a new
   sock shows up in every picker once it is in the "colorways" collection.
   ES5 only (Instagram in-app browser, older Safari).
   ========================================================================== */
(function () {
  'use strict';
  var T = window.BM_I18N || {};
  function data() {
    return window.BM_COLORWAYS || { women: [], men: [], all: [], originals: ['aegean', 'onyx', 'artemis'], menSizes: [2, 4] };
  }
  function tt(s, tok, val) { return String(s).replace(tok, val); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function byKey(key) { var a = data().all; for (var i = 0; i < a.length; i++) { if (a[i].key === key) return a[i]; } return null; }
  function current() { var a = data().all; for (var i = 0; i < a.length; i++) { if (a[i].current) return a[i]; } return null; }

  /* Colours on offer for a pack of `size` pairs: women's always, men's only for the men's pack sizes. */
  function forSize(size) {
    var d = data();
    var list = d.women.slice();
    if (d.men.length && d.menSizes.indexOf(size) !== -1) list = list.concat(d.men);
    return list;
  }
  function emptyMix(list) { var m = {}; for (var i = 0; i < list.length; i++) { m[list[i].key] = 0; } return m; }
  function total(mix) { var n = 0; for (var k in mix) { if (mix.hasOwnProperty(k)) n += mix[k]; } return n; }

  /* Default mix (Robin 2026-10-07: keep the originals).
     On an original colour's own page, or a men's page: all of that colour, as before.
     Everywhere else: spread across the originals, preferring ones that ship now. */
  function defaultMix(list, size, curKey) {
    var mix = emptyMix(list);
    var cur = curKey ? byKey(curKey) : null;
    if (cur && !cur.soldout && mix.hasOwnProperty(cur.key) && (cur.original || cur.men)) { mix[cur.key] = size; return mix; }
    var orig = [], now = [], i;
    for (i = 0; i < list.length; i++) { if (list[i].original && !list[i].soldout) orig.push(list[i]); }
    for (i = 0; i < orig.length; i++) { if (!orig[i].backorder) now.push(orig[i]); }
    var pick = now.length ? now : orig;
    if (!pick.length) { for (i = 0; i < list.length; i++) { if (!list[i].soldout) pick.push(list[i]); } }
    if (!pick.length) return mix;
    for (i = 0; size > 0; i++, size--) { mix[pick[i % pick.length].key] += 1; }
    return mix;
  }

  /* Order note for packing, e.g. "2× Aegean Blue · 1× Black Cat · 1× Men's Onyx Black" (always English names). */
  function colorsString(list, mix) {
    var out = [];
    for (var i = 0; i < list.length; i++) { if (mix[list[i].key] > 0) out.push(mix[list[i].key] + '× ' + list[i].name); }
    return out.join(' · ');
  }
  /* Full pack and the shopper taps + on another colour: take one pair from the colour holding the most (first in list order on ties). */
  function swapInto(list, mix, key) {
    var donor = null, best = 0;
    for (var i = 0; i < list.length; i++) { var k = list[i].key; if (k !== key && (mix[k] || 0) > best) { best = mix[k]; donor = k; } }
    if (!donor) return false;
    mix[donor] -= 1; mix[key] = (mix[key] || 0) + 1; return true;
  }
  function backorderKeys(list, mix) {
    var out = [];
    for (var i = 0; i < list.length; i++) { if (mix[list[i].key] > 0 && list[i].backorder) out.push(list[i].key); }
    return out;
  }
  function latest(keys) {
    var best = null;
    for (var i = 0; i < keys.length; i++) { var c = byKey(keys[i]); if (c && (!best || String(c.iso) > String(best.iso))) best = c; }
    return best;
  }
  /* Shopper-facing pre-order notice, with the latest batch date among the chosen colours. */
  function notice(keys) {
    if (!keys.length) return '';
    var names = [];
    for (var i = 0; i < keys.length; i++) { var c = byKey(keys[i]); if (c) names.push(c.label); }
    var joined = names.join(T.boJoiner || ' and ');
    var txt = names.length > 1 && T.backorderNoticeMulti ? tt(T.backorderNoticeMulti, '[names]', joined) : tt(T.backorderNotice || 'New Batch Arriving! [name] is on pre-order.', '[name]', joined);
    var l = latest(keys);
    if (l && l.date && T.batchDateText && l.date !== T.batchDateText) txt = txt.split(T.batchDateText).join(l.date);
    return txt;
  }
  /* Pre-order line shown at checkout and on the order (English, like Colors). */
  function property(keys) {
    var l = latest(keys);
    return 'Ships after the batch arrives ' + ((l && l.dateEn) || T.batchDateTextEn || 'soon');
  }

  /* Picker rows. p = class/attribute names of the picker that hosts them. */
  function rowsHTML(list, p) {
    var hasMen = false, hasWomen = false, i;
    for (i = 0; i < list.length; i++) { if (list[i].men) hasMen = true; else hasWomen = true; }
    var html = '', lastGroup = null;
    for (i = 0; i < list.length; i++) {
      var c = list[i];
      var group = c.men ? 'men' : 'women';
      if (hasMen && hasWomen && group !== lastGroup) {
        html += '<div class="bm-cw-group">' + esc(group === 'men' ? (T.cwMen || "Men's") : (T.cwWomen || "Women's")) + '</div>';
        lastGroup = group;
      }
      var label = c.men && hasWomen ? c.label.replace(/^Men's\s+/, '') : c.label;
      html +=
        '<div class="' + p.row + '" ' + p.attr + '-row="' + esc(c.key) + '">' +
          '<span class="' + p.dot + '" style="background:' + esc(c.bg || c.hex) + '" aria-hidden="true"></span>' +
          '<span class="' + p.name + '">' + esc(label) +
            (c.backorder ? ' <span class="bm-cw-tag">' + esc(T.preorderTag || 'Pre-order') + '</span>' : '') +
          '</span>' +
          '<div class="' + p.stepper + '">' +
            '<button type="button" class="' + p.step + '" ' + p.attr + '-minus="' + esc(c.key) + '" aria-label="' + esc(T.removeColor ? tt(T.removeColor, '[name]', c.label) : ('Remove ' + c.label)) + '">−</button>' +
            '<span class="' + p.count + '" ' + p.attr + '-count="' + esc(c.key) + '">0</span>' +
            '<button type="button" class="' + p.step + '" ' + p.attr + '-plus="' + esc(c.key) + '" aria-label="' + esc(T.addColor ? tt(T.addColor, '[name]', c.label) : ('Add ' + c.label)) + '">+</button>' +
          '</div>' +
        '</div>';
    }
    return html;
  }

  window.BMCW = {
    data: data, byKey: byKey, current: current, forSize: forSize, emptyMix: emptyMix, total: total,
    defaultMix: defaultMix, colorsString: colorsString, backorderKeys: backorderKeys, swapInto: swapInto,
    notice: notice, property: property, rowsHTML: rowsHTML
  };
})();
